// extracted by mini-css-extract-plugin
export default {"customFieldValue":"styles_customFieldValue__cEdvT","paymentTermsTrigger":"styles_paymentTermsTrigger__GSQ+U"};